<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Design Statistic">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'design-statistic',
        indexUri: 'design/statistic',
        storeId: ['main']
      }
    }
  }
}
</script>
<style lang="scss">
.page-design-statistic {
  .tablenav {
    input {
      max-width: 170px;
    }
  }
  .multiselect {
    width: 170px;
  }
}
</style>
